import React, { FC, useEffect, useState } from 'react';
import LiveTripCards from 'components/live-trip-cards';
import OnlineStatus from 'components/base/online-status';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { PartnerRiderType } from 'models/partner.model';
import { getUserName } from 'utils/functions';

type Props = {
  show: boolean;
  setShow: (arg1: boolean) => void;
  rider: PartnerRiderType;
};
const ViewOrdersSideModal: FC<Props> = ({ show, setShow, rider }) => {
  const [orderData, setOrderData] = useState([] as any);

  useEffect(() => {
    if (rider.orders) {
      const orders = rider.orders.map((o) => ({
        ...o,
        rider: { first_name: rider.first_name, last_name: rider.last_name }
      }));
      setOrderData(orders);
    }
  }, [rider]);

  return (
    <BaseModal
      position='right'
      isOpen={show}
      onRequestClose={() => {
        setShow(false);
      }}
      size='wide'
      title={
        <div className='flex justify-start gap-5 items-center'>
          <p className='text-2xl font-medium my-6'>{getUserName(rider)}</p>
          <OnlineStatus online />
        </div>
      }>
      {orderData?.length === 0 ? (
        <p className='text-center my-12 text-lg'>There are there no trips to show </p>
      ) : (
        <LiveTripCards orders={orderData} modalView />
      )}
    </BaseModal>
  );
};

export default ViewOrdersSideModal;
